import React from 'react';
import { Wifi, WifiOff, RefreshCw, CloudUpload } from 'lucide-react';
import { useOffline } from '../contexts/OfflineContext';

// Header badge: shows connectivity + pending offline captures with a manual sync.
const SyncIndicator = () => {
  const { online, pendingCount, syncing, sync } = useOffline();

  if (online && pendingCount === 0) {
    return (
      <div className="hidden sm:flex items-center gap-1.5 text-xs text-emerald-600" data-testid="sync-indicator-online" title="Online">
        <Wifi className="w-4 h-4" />
        <span className="hidden md:inline">Online</span>
      </div>
    );
  }

  return (
    <button
      onClick={() => online && sync()}
      disabled={!online || syncing}
      data-testid="sync-indicator"
      title={online ? 'Sync pending captures' : 'Offline — captures will sync automatically when reconnected'}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors ${
        online
          ? 'bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200'
          : 'bg-red-50 text-red-700 border border-red-200 cursor-default'
      }`}
    >
      {online ? (
        syncing ? <RefreshCw className="w-4 h-4 animate-spin" /> : <CloudUpload className="w-4 h-4" />
      ) : (
        <WifiOff className="w-4 h-4" />
      )}
      <span data-testid="sync-pending-count">
        {!online
          ? (pendingCount > 0 ? `Offline · ${pendingCount} queued` : 'Offline')
          : (syncing ? 'Syncing…' : `${pendingCount} to sync`)}
      </span>
    </button>
  );
};

export default SyncIndicator;
